import styled from 'styled-components';
import { rem } from '@mantine/core';

const COLUMN_WIDTH = `clamp(${rem(270)}, 23vw, ${rem(440)})`;

export const InvestorDetailsColumns = styled.div<{ $detailsCollapsed: boolean }>`
	display: flex;
	gap: 1rem;
	flex: 1;
	min-height: 0;
	overflow: hidden;

	> .column {
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;

		scrollbar-width: none;
		-ms-overflow-style: none;

		padding-bottom: 4rem;

		&::-webkit-scrollbar {
			width: 0;
			height: 0;
		}

		> .column-content {
			display: flex;
			flex-direction: column;
			gap: 1rem;
			padding-bottom: 1rem;
		}
	}

	/* Collapsing swaps width for visibility rather than unmounting, so the column's scroll
	   position survives a collapse/expand round trip. The content keeps its full width and
	   is clipped by the shrinking column, so the cards slide away instead of reflowing. */
	> .details {
		flex: 0 0 ${COLUMN_WIDTH};
		min-width: ${({ $detailsCollapsed }) => ($detailsCollapsed ? 0 : COLUMN_WIDTH)};
		max-width: ${({ $detailsCollapsed }) => ($detailsCollapsed ? 0 : COLUMN_WIDTH)};
		visibility: ${({ $detailsCollapsed }) => ($detailsCollapsed ? 'hidden' : 'visible')};
		transition:
			visibility 0.3s,
			min-width 0.3s ease-in-out,
			max-width 0.3s ease-in-out;

		> .column-content {
			width: ${COLUMN_WIDTH};
		}
	}

	> .main {
		flex: 1 1 auto;
		min-width: 0;
		padding-bottom: 4rem;
	}

	> .activity {
		flex: 0 0 ${COLUMN_WIDTH};
	}
`;

export const SKELETON_OVERLAY = {
	position: 'absolute',
	top: '50%',
	left: 0,
	transform: 'translateY(-50%)',
} as const;
